import React from "react";
import "./NpaReport.css";
import comingSoonIcon from "../assets/19.png"; // Use a relevant illustration

const NpaReport = () => {
  return (
    <div className="npa-report-container">
      <div className="npa-report-left-panel">
        <h1 className="npa-report-left-panel-title">NPA Report</h1>
        <p className="npa-report-left-panel-message">
          🚧 This section is under active development.
        </p>
        <p className="npa-report-left-panel-message">
          Soon you will be able to track Non-Performing Assets (NPA), view overdue loans, 
          penalties, and generate detailed reports for better financial control.
        </p>
        <p className="npa-report-left-panel-message">
          Our team is working hard to deliver a powerful and interactive NPA reporting tool.
        </p>

        <div className="npa-report-left-panel-progress-bars">
          <div className="npa-report-left-panel-progress-bar bar1"></div>
          <div className="npa-report-left-panel-progress-bar bar2"></div>
          <div className="npa-report-left-panel-progress-bar bar3"></div>
          <div className="npa-report-left-panel-progress-bar bar4"></div>
          <div className="npa-report-left-panel-progress-bar bar5"></div>
        </div>
      </div>

      <div className="npa-report-right-panel">
        <img
          src={comingSoonIcon}
          alt="Coming Soon Graph"
          className="npa-report-right-panel-image"
        />
      </div>
    </div>
  );
};

export default NpaReport;
